import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from '../../config'
import {Link, GetStartedInput} from '../../components'
import Styles from './Media.css'
import container from '../../helpers/container'

@CSSModules(Styles)
export default class Media extends Component {
  constructor(props) {
    super(props)
    this.state = {
      launch: false
    }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  pressHits = [
    {
      outlet:'Fast Company',
      headline: 'New investment site helps people avoid funding gun manufacturers, military contractors',
      link: 'https://www.fastcompany.com/40589913/new-investment-site-helps-people-avoid-funding-gun-manufacturers-military-contractors'
    },
    {
      outlet:'Pensions and Investments',
      headline: 'New tool lets investors scrutinize funds for weapons companies',
      link: 'http://www.pionline.com/article/20180806/PRINT/180809907/new-tool-lets-investors-scrutinize-funds-for-weapons-companies'
    },
    {
      outlet:'Common Dreams',
      headline: 'Are You Funding Gun Violence?',
      link: 'https://www.commondreams.org/views/2018/06/27/are-you-funding-gun-violence'
    },
    {
      outlet:'Common Dreams',
      headline: 'Who Is Making a Killing on Killing?',
      link: 'https://www.commondreams.org/views/2018/06/26/who-making-killing-killing'
    },
    {
      outlet:'As You Sow blog',
      headline: 'In the wake of yet another mass shooting, a call for weapons-free finance',
      link: 'https://www.asyousow.org/blog/2018/2/27/in-the-wake-of-yet-another-mass-shooting-a-call-for-weapons-free-finance'
    },
  ]

  clickViewMore = (release) =>{
    const newState = {}
    newState[release] = !this.state[release]
    this.setState(newState)
  }

  renderButton = (label, title, date, subtitle, renderFn) => {
    const btnLabel = (!this.state[label] ) ? 'View the Full Release' : 'View Less'
    return(
      <div styleName='press-release-wrapper' >
        <div styleName='press-release-title'>{title}</div>
        <p><strong>{date} &mdash; {subtitle}</strong></p>
        <div styleName='press-release-button' onClick={() => this.clickViewMore(label) }>
          <i
            styleName='press-release-icon'
            className={ this.state[label] ? 'fa fa-caret-down':'fa fa-caret-right' }
          />
          &nbsp;{btnLabel}
        </div>
        { (this.state[label]) ? renderFn() : null}
      </div>
    )
  }

  renderReleaseLaunchButton = () => {
    const label = 'launch'
    const title = 'First of Its Kind Web Tool Lets You Know if You’re Funding Gun Violence and War'
    const date = 'June 26, 2018'
    const subtitle = 'Weapon Free Funds, a new tool from non-profit groups As You Sow and CODEPINK, was released today'
    const renderFn = () => { return this.renderReleaseLaunch() }

    return this.renderButton(label, title, date, subtitle, renderFn)
  }

  renderReleaseLaunch = () => {
    return (
      <div styleName='release-wrap'>

        <p><strong>OAKLAND, CA &mdash; June 26, 2018 &mdash; Weapon Free Funds</strong>, a new tool from non-profit groups As You Sow and CODEPINK, was released today to help individuals, communities, universities and others review their mutual fund investments for holdings in military contractors and gun manufacturers and retailers. Handguns, assault rifles, ammunition, cluster munitions, landmines and nuclear weapons are often embedded in commonly-held mutual funds and ETFs.</p>

        <p>Employer-offered 401(k)s, personal mutual fund portfolios and pension funds are likely to be invested in weapons manufacturers, including large defense contractors like Lockheed Martin and Raytheon, and gun companies such as American Outdoor Brands—the company that makes the assault rifle that was used in the Parkland, Florida, school shooting.</p>

        <p>“If you’re an investor who doesn’t want to support the weapons industry, you have to first know what you own,” said Andrew Behar, CEO of As You Sow. “It’s important that people are offered the choice to invest responsibly and avoid companies profiting from violence—especially when many of the clean funds outperform.”</p>

        <p>Weapon Free Funds, covering 3,000 of the most commonly-owned U.S. mutual funds from major asset managers like Vanguard, Fidelity and BlackRock, allows investors to find out if their mutual fund investments are being used to finance makers of military weapons and civilian firearms, and to find alternative, socially-responsible options that avoid the war economy. Investors can easily see how their investments support major military contractors, cluster munitions (banned in 100+ countries), nuclear weapons, gun manufacturers and gun retailers.</p>

        <p>The details of child concentration camps at our borders is a shining example of how military contractors do business, and our investments are subsidizing humanitarian crises and untold destruction both at home and around the world.</p>

        <p>“There should be no profit from war. We should not be making a killing on killing,” Jodie Evans, co-founder of CODEPINK, said. “To end violence and war we can start with our cities, states, schools, and churches acting from their values.”</p>

        <p>The good news is that more than $40 billion has already been divested from war and weapons, and these weapon-free funds can be found in the database.</p>

        <p>"Domini Funds has always sought to avoid investing in weapons,” Amy Domini, founder of Domini Funds, said. “Our principles of universal human dignity and ecological sustainability mean that we must exclude the manufacturers of products that are only intended to cause harm to people and the planet. You can invest wisely without sacrificing your values.”</p>

        <p>Activists have been speaking out against investing in war. Earlier this year, activists rallied in front of BlackRock, the world’s largest investment firm, demanding an end to profiting from war, death and destruction. As we sludge through another year of the wars without end, individuals and institutions are speaking up and removing their assets from war. Years of diverting limited federal resources to line the pockets of CEOs, who are making millions while workers cannot afford basic necessities like food and shelter, has resulted in a growing movement to align our investments with our values. Weapon Free Funds brings transparency to this movement.</p>

        <p>"Chorus Foundation has never invested in weapons, because it does not align with our values,” Cuong Hoang of the Chorus Foundation said. “Building community power to dismantle extractive economies means that we focused our investments on solutions.”</p>

        <p>“As we continue to spend out our family foundation, we continue to be, and always have been, committed to investing in funds and businesses that promote an economy of peace. We will never profit from war," said Lauren Embrey of the Embrey Family Foundation</p>

        <p>CODEPINK is leading an 85-member coalition in their Divest from the War Machine campaign  to use this tool to encourage mayors, governors, universities and pension funds managers to stop funding violence. Beyond moral concerns, weapon investments carry real financial risks. Recently, the stock market reacted to news of peace on the Korean peninsula with a significant drop in weapons manufacturer stock. Institutions have also divested from weapons and see marked increase in performance, including Hampshire College in Massachusetts.</p>

        <p>"One might think this [divesting from weapons] is a risky approach for a small college,” John Courtmanche, spokesman for Hampshire College, said. “But following this policy since 2011, our average five-year investment returns have performed better (6.4%) than the average return of the more than 800 colleges tracked by both NACUBO Commonfund Study (5.4%) and Bloomberg Endowment Index (4.5%). In the fiscal year ending June, 2017, Hampshire logged an annual return of 24.5%, much higher than the industry average of 12.7% that year for endowments and foundations."</p>

        <p><strong>Weapon Free Funds</strong> is available at <Link to={config.routes.home} title='Home | Weapon Free Funds' xstrong={true}>weaponfreefunds.org</Link>. To learn more about the movement to say no to guns, war, and violence visit <Link to={config.links.dfw} title='Divest from the War Machine' xstrong={true}>www.divestfromwarmachine.org</Link></p>

        <p><strong><em># # #</em></strong></p>

        <p><em><Link to={config.links.ays} title='As You Sow' xstrong={true}>As You Sow</Link> is a nonprofit organization that promotes environmental and social corporate responsibility through shareholder advocacy, coalition building and innovative legal strategies.</em></p>

        <p><em><Link to={config.links.codepink} title='CODEPINK' xstrong={true}>CODEPINK</Link> is a women-led grassroots organization working to end U.S. wars and militarism, support peace and human rights initiatives, and redirect our tax dollars into healthcare, education, green jobs and other life-affirming programs.</em></p>

      </div>
    )
  }

  render() {
    const title = 'Media'
    const description = 'Get your money out of weapon stocks. See media related to Weapon Free Funds.'
    const url = config.domain + config.routes.media

    return (
      <div>
        {container.helmet(title, description, url)}

        <div styleName='page'>
          <div styleName='container'>
            <div styleName='container-inner'>
              <div styleName='anchor' id='top'/>
              <div styleName='title'>{title}</div>
              <div styleName='answers'>
                <div styleName='answer'>
                  <div styleName='anchor' id='contact'/>
                  <div styleName='answer-title'>
                    Get in touch
                  </div>
                  <div styleName='answer-info'>

                    <p><strong>Contact form</strong></p>
                    <p>
                      <Link
                        xstrong={true}
                        styleName='contact'
                        to={config.links.contact}
                        title='Contact form'>
                        As You Sow contact form
                      </Link>
                    </p>
                    <br/>
                    <p><strong>Media Inquiries</strong></p>
                    <p>Jill Courtenay, Communications Project Manager, As You Sow</p>
                    <p>
                      <Link
                        xstrong={true}
                        styleName='contact'
                        to={config.links.contactJill}
                        title='Email Jill Courtenay, Communications Project Manager, As You Sow'>
                        Email
                      </Link>
                    </p>
                    <br/>
                    <p><strong>General Inquiries</strong></p>
                    <p>Andrew Montes, Director of Digital Strategies, As You Sow</p>
                    <p>
                      <Link
                        xstrong={true}
                        styleName='contact'
                        to={config.links.contactAndrew}
                        title='Email Andrew Montes, Director of Digital Strategies, As You Sow  '>
                        Email
                      </Link>
                    </p>
                  </div>
                </div>

                <div styleName='answer' >
                  <div styleName='anchor'/>
                  <div styleName='answer-title'>
                    Press coverage and blog posts
                  </div>
                  <div styleName='answer-info'>

                    {this.pressHits.map( (pressHit, i) => {
                      return (
                        <div key={i} styleName='press-item'>
                          <Link
                            to={pressHit.link}
                            title={pressHit.outlet + ' - ' + pressHit.headline}>
                            <h3 styleName='press-item-outlet'>
                              {pressHit.outlet}
                            </h3>
                            <div>{pressHit.headline}</div>
                          </Link>
                        </div>
                      )
                    })}

                  </div>
                </div>

                <div styleName='answer' >
                  <div styleName='anchor'/>
                  <div styleName='answer-title'>
                    Media releases
                  </div>
                  <div styleName='answer-info'>

                    { this.renderReleaseLaunchButton() }

                  </div>
                </div>
              </div>

            </div>
          </div>

          <GetStartedInput />

        </div>
      </div>
    )
  }
}